var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easylogin"},[(!_vm.isLogin)?_c('div',{staticClass:"loginloading"},[_c('img',{attrs:{"width":"300","src":require("@/assets/simple/loginloading.gif"),"alt":""}})]):_c('div',{staticClass:"error"},[_c('img',{attrs:{"width":"320","src":require("@/assets/simple/loginerror.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }